import { RouteAPI } from '../mixins/route-api';

export const NotificationAPI = {
  mixins: [RouteAPI],
  methods: {
    async getNotificationsAPI(page = 1, limit = 10) {
      try {
        const res = await this.$http.get(this.routeAPIGetNotifications(), {
          params: {
            'page': page,
            'limit': limit,
          },
        });
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },
    async removeNotificationAPI(timestamp) {
      try {
        const res = await this.$http.post(this.routeAPIRemoveNotification(), {
          timestamp: timestamp,
        });
        return res.data;
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },
    async setNotificationViewedAPI() {
      try {
        const res = await this.$http.post(this.routeAPISetNotificationViewed());
        if (res.data.status === 0) {
          this.$store.dispatch('notifications/setAllNotificationViewed');
        }
      } catch (error) {
        console.log(error);

        return {
          status: 1,
          message: 'Something went wrong!',
        };
      }
    },
  },
};
